// Ladda loading buttons

import * as Ladda from 'ladda';

$(document).ready(() => {

    Ladda.bind('.ladda-button', {timeout: 2000});

});